
import { computed, defineComponent, onMounted, PropType, reactive } from 'vue'

// components
import NewPagination from '@/common/new-components/NewPagination/index.vue'
import NewLimit from '@/common/new-components/NewLimit/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import Modal from '@/common/components/UI/Modal/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'
import TablePagination from '@/common/components/UI/TablePagination/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import { useTablesStore } from '@/modules/TablesModule/store/useTablesStore'
import { useRoute } from 'vue-router'
import { ColumnItemT } from '@/core/types/tables.types'

import draggable from 'vuedraggable'

export default defineComponent({
    components: {
        Loader,
        TablePagination,
        NewPagination,
        NewLimit,
        Modal,
        Checkbox,
        TheButton,
        draggable,
    },
    props: {
        rows: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
        columns: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        quantityLoading: {
            type: Boolean,
            default: false,
        },
        pagination: {
            type: Boolean,
            default: false,
        },
        paginationTotalPages: {
            type: Number,
            default: 1,
        },
        paginationLimit: {
            type: Number,
            default: 1,
        },
        paginationTotalItems: {
            type: Number,
            default: 1,
        },
        paginationCurrentPage: {
            type: Number,
            default: 1,
        },
        isWrap: {
            type: Boolean,
            default: false,
        },
        withLimit: {
            type: Boolean,
            default: false,
        },
        isColumnsModal: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['change-page', 'change-limit'],
    setup(props, { emit }) {
        const { path } = useRoute()

        const state = reactive({
            columns: [] as ColumnItemT[],
            drag: false,
        })

        const tablesStore = useTablesStore()

        const emitChangePage = (page: number) => {
            emit('change-page', page)
        }

        const emitChangeLimit = (limit: number) => {
            emit('change-limit', limit)
        }

        const getColumns = () => (state.columns = tablesStore.getColumns(path, props.columns))
        const setColumns = () => tablesStore.setColumns(path, state.columns)

        const filteredColumns = computed(() => state.columns.filter((c) => c.isChecked))

        const onAllColumnsSelect = (value: boolean) => {
            state.columns.forEach((column) => {
                column.isChecked = value
            })
        }

        const isAllColumnsChecked = computed(() =>
            state.columns.every((column) => column.isChecked)
        )

        const onDragEnd = () => {
            state.drag = false
        }

        onMounted(getColumns)

        return {
            path,
            state,
            tablesStore,
            emitChangePage,
            emitChangeLimit,
            setColumns,
            filteredColumns,
            onAllColumnsSelect,
            isAllColumnsChecked,
            onDragEnd,
        }
    },
})
